module.exports = __webpack_public_path__ + "img/p6.00ae7c3d.png";